// Import package.json to get the version
import packageInfo from "../package.json"

// Export the version for use in components
export const appVersion = packageInfo.version